import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { projectInfo } from '../../../../environments/version';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  projectInfo = projectInfo;
  protected readonly environment = environment;
  currentYear = new Date().getFullYear();
  version: string | undefined;
  buildDate: string | undefined;
  commitHash: string | undefined;

  ngOnInit(): void {
    this.initializeFooterDetails();
  }

  // This method initializes the footer details by setting the version, build date, and commit hash.
  // It formats the build date to "Month Day, Year" and truncates the commit hash to the first 6 characters.
  private initializeFooterDetails(): void {
    this.version = ' Version:             ' + this.projectInfo.name + ' : ' + this.projectInfo.version + '\n';
    this.buildDate = 'Build Date:        ' + new Date(this.projectInfo.gitBuildDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) + '\n';
    this.commitHash = 'Commit Hash:   ' + this.projectInfo.commitHash.substring(0, 6);
  }
}
